<template>
    <div class="hdr-outer" id="headerScroll">
      <div class="lmd-menu" id="menuOpen">
        <nav>
          <ul>
            <li>
              <router-link :class="{ active: $route.path === '/' }" to="/" id="homeMenuLink" @click="closeMenu"><i title="Home"></i> <span>Home</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/our-services' }" to="/our-services" id="ourServicesLink" @click="closeMenu"><i title="Services"></i> <span>Services</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/Industries' }" to="/Industries" id="ourIndustriesLink" @click="closeMenu"><i title="Industries"></i> <span>Industries</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/client' }" to="/client" id="ourClientsLink" @click="closeMenu"><i title="Clients"></i> <span>Clients</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/career' }" to="/career" id="ourCareersLink" @click="closeMenu"><i title="Career"></i> <span>Careers</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/our-team' }" to="/our-team" id="ourTeamLink" @click="closeMenu"><i title="Teams"></i> <span>Our Team</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/about-us' }" to="/about-us" id="AboutUsLink" @click="closeMenu"><i title="About-us"></i> <span>About Us</span></router-link>
            </li>
            <li>
              <router-link :class="{ active: $route.path === '/blogs' }" to="/blogs" id="BlogsLink" @click="closeMenu"><i title="Blogs"></i> <span>Blogs</span></router-link>
            </li>
          </ul>
        </nav>
      </div>
      <header class="lmd-header">
        <div class="container-fluid">
          <div class="custom-row">
            <div class="site-logo">
              <router-link to="/">
                <img src="@/assets/images/logo.svg" @click="closeMenu" alt="Logo">
              </router-link>
            </div>
            <div class="lmd-hdr-right">
              <div class="menu-icon">
                <button id="menuclick">
                  <span class="hamb-top"></span>
                  <span class="hamb-mid"></span>
                  <span class="hamb-btm"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import customJSFunction from "@/assets/js/custom.js";
  import $ from 'jquery';
  
  export default defineComponent({
    name: "HomePage",
    mounted() {
      customJSFunction();
      this.setupMenuBehavior();
    },
    beforeUnmount() {
      this.removeMenuListeners();
    },
    watch: {
      '$route'(to, from) {
        this.closeMenu();
      }
    },
    methods: {
      setupMenuBehavior() {
        document.addEventListener('click', this.handleOutsideClick);
      },
      removeMenuListeners() {
        document.removeEventListener('click', this.handleOutsideClick);
      },
      handleOutsideClick(event: MouseEvent) {
        const menu = document.getElementById('menuOpen');
        const menuButton = document.getElementById('menuclick');
  
        if (
          menu && menuButton &&
          !menu.contains(event.target as Node) &&
          !menuButton.contains(event.target as Node) &&
          menu.classList.contains('show-menu')
        ) {
          this.closeMenu();
        }
      },
      closeMenu() {
            setTimeout(() => {
                $('#menuOpen').removeClass('show-menu');
                $('#menuclick').removeClass('close-menu');
            }, 100); // 100ms delay
            }
    }
  });
  </script>